import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class MetaTagsService {

    constructor(private titleService: Title,
        private router: Router,
        private metaService: Meta) { }

    setMetaTags(data) {

        this.titleService.setTitle(data.title);


        if (data.title) {
            this.metaService.updateTag({ name: 'title', content: data.title })
        } else {
            this.metaService.removeTag("name='title'")
        }


        if (data.description) {
            this.metaService.updateTag({ name: 'description', content: data.description })
        } else {
            this.metaService.removeTag("name='description'")
        }


        if (data.robots) {
            this.metaService.updateTag({ name: 'robots', content: data.robots })
        } else {
            this.metaService.updateTag({ name: 'robots', content: "follow,index" })
        }

        if (data.ogUrl) {
            this.metaService.updateTag({ property: 'og:url', content: data.ogUrl })
        } else {
            this.metaService.updateTag({ property: 'og:url', content: environment.web + this.router.url })
        }

        if (data.ogTitle) {
            this.metaService.updateTag({ property: 'og:title', content: data.ogTitle })
        } else {
            this.metaService.removeTag("property='og:title'")
        }

        if (data.ogDescription) {
            this.metaService.updateTag({ property: 'og:description', content: data.ogDescription })
        } else {
            this.metaService.removeTag("property='og:description'")
        }

        if (data.ogImage) {
            this.metaService.updateTag({ property: 'og:image', content: data.ogImage })
        } else {
            this.metaService.removeTag("property='og:image'")
        }
    }

}


